import { optional, withDependencies } from '@wix/thunderbolt-ioc'
import type { IMpaNavigation } from 'feature-mpa-navigation'
import { MpaNavigationSymbol, isSameUrlExceptQuery } from 'feature-mpa-navigation'
import type { IRouter, ICommonNavigationClickHandler } from './types'
import { Router } from './symbols'
import { getUrlHash, getUrlQueryParam } from './urlUtils'

const commonNavigationClickHandlerFactory = (
	router: IRouter,
	mpaNavigation?: IMpaNavigation
): ICommonNavigationClickHandler => {
	return {
		commonNavigationClickHandler: (anchor) => {
			let href = anchor.getAttribute('href')
			href = href?.replace(/\uFFFD/g, '').replace(/%EF%BF%BD/g, '') ?? ''

			if (!href) {
				return false
			}

			if (anchor.getAttribute('target') === '_blank') {
				return false
			}
			if (!router.isInternalValidRoute(href)) {
				return false
			}

			const hashAnchor = getUrlHash(href)
			const dataAnchor = anchor.getAttribute('data-anchor')

			if (
				window &&
				!isSameUrlExceptQuery(window.location.href, href) &&
				mpaNavigation?.isEligible({ anchorCompId: hashAnchor, anchorDataId: dataAnchor })
			) {
				return mpaNavigation.navigate(href)
			}

			const disableScrollToTop = getUrlQueryParam(href, 'disableScrollToTop') === 'true'

			router.navigate(href, {
				anchorDataId: dataAnchor || hashAnchor || 'SCROLL_TO_TOP',
				disableScrollToTop,
			})
			return true
		},
	}
}

export const CommonNavigationClickHandler = withDependencies(
	[Router, optional(MpaNavigationSymbol)],
	commonNavigationClickHandlerFactory
)
